import { GroupMessage, GroupState, GroupMember } from "./types";

export function serializeState(messages: GroupMessage[]): GroupState {
  const state: GroupState = {
    members: [],
    confirmedCheckouts: [],
    finalizedCheckouts: [],
  };

  // Find the last ORDER_FINISHED message to determine where to start processing
  let lastOrderFinishedIndex = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].type === "ORDER_FINISHED") {
      lastOrderFinishedIndex = i;
      break;
    }
  }

  // Process messages starting from after the last ORDER_FINISHED
  const relevantMessages = messages.slice(lastOrderFinishedIndex + 1);
  const memberMap = new Map<string, GroupMember>();

  for (const message of relevantMessages) {
    switch (message.type) {
      case "JOIN":
        memberMap.set(message.clientId, {
          clientId: message.clientId,
          cart: message.cart,
          state: "ordering",
          joinAt: Date.now(), // We could add timestamp to messages if needed
        });
        break;

      case "LEAVE":
        const now = Date.now();
        if (now - message.timestamp > 1000 * 60) {
          memberMap.delete(message.clientId);
        }
        break;
      case "CART_UPDATE":
        const existingMember = memberMap.get(message.clientId);
        if (existingMember) {
          memberMap.set(message.clientId, {
            ...existingMember,
            cart: message.cart,
          });
        }
        break;

      case "ORDER_CONFIRMED":
        const confirmedMember = memberMap.get(message.clientId);
        if (confirmedMember) {
          memberMap.set(message.clientId, {
            ...confirmedMember,
            state: "confirmed",
          });
        }
        const confirmedCheckout = {
          id: message.checkoutId,
          clientId: message.clientId,
        };
        if (
          !state.confirmedCheckouts.some((c) => c.id === message.checkoutId)
        ) {
          state.confirmedCheckouts.push(confirmedCheckout);
        }
        break;

      case "ORDER_FINALIZED":
        const finalizedMember = memberMap.get(message.clientId);
        if (finalizedMember) {
          memberMap.set(message.clientId, {
            ...finalizedMember,
            state: "finalized",
          });
        }
        for (const checkoutId of message.checkoutIds) {
          const finalizedCheckout = {
            id: checkoutId,
            clientId: message.clientId,
          };
          if (!state.finalizedCheckouts.some((c) => c.id === checkoutId)) {
            state.finalizedCheckouts.push(finalizedCheckout);
          }
        }
        break;
    }
  }

  state.members = Array.from(memberMap.values());
  return state;
}

export function appendMessage(
  eventLog: GroupMessage[],
  newMessage: GroupMessage,
): GroupMessage[] {
  return [...eventLog, newMessage];
}
